import { useDispatch, useSelector } from 'react-redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

export const baseOnboardingUrl = 'https://newtonflaskserver-hfgkcrewf4fgedc6.westus-01.azurewebsites.net';
//export const baseOnboardingUrl = 'http://localhost:5002';
